<template>
  <div class="containers mx-auto allBoxImg mt-10">
    <div class="flex">
      <div class="w-full pt-16 px-32">
        <div class="md:px-0 lg:px-0 text-center">
          <div class="text-gray-500">
            <p class="pt-2">
              It looks like you have not tagged yourself correctly in My Profile. The learners in band 5 and 4A in operations need to start at Beginner proficiency level and subsequently move to higher levels of proficiency. You should be
              at a beginner for all skills unless you have already completed a Beginner Wave. Check on Genome now to see which skills you need to update. Once you fix your My Profile, you will get access to Solidify again within 48 hours.
            </p>
          </div>
          <div class="pt-8">
            <a href="javascript:;"><img src="@/assets/images/support.png" class="mx-auto" /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LearnerGating',
  setup() {
    console.log('LearnerGating Vue');
  },
});
</script>
<style scoped>
/* .ul-nav {
} */

.ul-nav ul {
  display: flex;
  width: 100%;
}

.ul-nav ul li.active {
  background: #00adcf !important;
  color: #fff !important;
}

.ul-nav ul li::before {
  content: '';
  background: #fff;
  width: 31px;
  height: 32px;
  position: absolute;
  z-index: 0;
  left: -16px;
  top: 5px;
  transform: rotate(45deg);
  border-top: 1px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;
}

.ul-nav ul li {
  color: #707070 !important;
  margin-right: 2px !important;
}

.ul-nav ul li {
  list-style: none;
  flex: 1;
  padding: 10px;
  text-align: center;
  position: relative;
  border-width: 1px 0 1px 1px;
  border-style: solid;
  border-color: #d9d9d9;
  background-color: #eee;
  color: #979797;
  font-size: 16px;
  min-width: 175px;
  margin: 8px 10px;
}

.ul-nav ul li::after {
  content: '';
  background: inherit;
  width: 31px;
  height: 32px;
  position: absolute;
  z-index: 1;
  right: -16px;
  top: 5px;
  transform: rotate(45deg);
  border-top: 1px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;
}

.ul-nav ul li {
  padding-left: 20px !important;
}

.box-overflow1 {
  max-height: 68vh;
  overflow-y: auto;
}

@media screen and (max-width: 768px) {
  .ul-nav {
    overflow-x: scroll;
  }

  .box-overflow1 {
    max-height: initial;
    overflow-y: auto;
  }
}
</style>
